export default "__VITE_PUBLIC_ASSET__4d0cc02d__"